import {
  IInitialStateDuType,
  iInitialStateDuType,
} from "../../Interfaces/IDuType";
import {
  IInitialStateFamilyGroup,
  iInitialStateFamilyGroup,
} from "../../Interfaces/IFamilyGroup";
import {
  IInitialStateProduct,
  iInitialStateProduct,
} from "../../Interfaces/Product/IProduct";
import moment from "moment";
import { setCheckBoxData } from "../../helpers/rowMatchHelper";
import {
  DimensionLengthUOMOptions,
  DimensionWeightUOMOptions,
} from "../../Interfaces/Product/IProductFormField";
import {
  iInitialStateFamilyGroupManagement,
  IInitialStateFamilyGroupManagement,
} from "../../Interfaces/IFamilyGroupManagement";
import {
  undefinedToStringConverter,
} from "../../helpers/StringHelpersMethods";
import { consolelog } from "../../helpers/consolelog";
import { IFoodVolumetricsReviewType, initialStateFoodVolumetricsReviewType } from "../../Interfaces/IFoodVolumetricsReviewType";

export const SelectedMenu = (menu: string): boolean => {
  consolelog(menu);
  let result = false;
  switch (menu) {
    case "Query":
    case "Attributes":
    case "Measurements-Clothing":
    case "Measurements":
    case "Hierarchy":
    case "Food Volumetrics":
      result = true;
      break;
    default:
      result = false;
      break;
  }
  return result;
};

export const PopupFormatter = (
  parentName: string,
  selectedMenu: string,
  value: any
):
  | IInitialStateDuType
  | IInitialStateProduct
  | IInitialStateFamilyGroup
  | IInitialStateFamilyGroupManagement
  | IFoodVolumetricsReviewType => {
  if (parentName === "/familyGroupAdmin" && selectedMenu === "Summary") {
    const newPayload: IInitialStateFamilyGroup = {
      ...iInitialStateFamilyGroup,
      values: {
        FamilyGroup: value.FamilyGroup,
        BusinessUnit: value.BusinessUnit,
        SuperCategory: value.SuperCategory,
        Category: value.Category,
        SubCategory: value.SubCategory,
        Segment: value.Segment,
        ProductCount: value.TotalRecords,
        UpdatedDate: moment(value.UpdatedDate).format("YYYY-MM-DD"),
        CreatedDate: moment(value.CreatedDate).format("YYYY-MM-DD"),
        Company: value.Company,
        FamilyGroupNew: value.familyGroupNew,
        SuperCatDesc: value.SuperCatDesc,
        SubCategoryDesc: value.SubCategoryDesc,
        CategoryDesc: value.CategoryDesc,
        BusinessUnitDesc: value.BusinessUnitDesc,
        SegmentDesc: value.SegmentDesc,
        ProductType: value?.ProductType || "",
        UpdatedBy: value.UpdatedBy,
      },
      dirty: true,
      setPopup: true,
    };
    return newPayload;
  } else if (
    parentName === "/familyGroupAdmin" &&
    selectedMenu === "Management"
  ) {
    const newPayload: IInitialStateFamilyGroupManagement = {
      ...iInitialStateFamilyGroupManagement,
      values: {
        FamilyGroup: value.FamilyGroup,
        FamilyGroupDescription: value.FamilyGroupDescription,
        ProductType: value.ProductType,
        LPFamilyGroupMix: !!(value?.LpFamilyGroupMix),
        MLPFamilyGroupMix: !!(value?.MlpFamilyGroupMix),
        SerialControl: value?.SerialControl || iInitialStateFamilyGroupManagement.values.SerialControl,
        SerialInputMask: value.SerialInputMask,
        UpdatedDate: moment(value.UpdatedDate).format("YYYY-MM-DD"),
        CreatedDate: moment(value.CreatedDate).format("YYYY-MM-DD"),
        StrapTotes: value.StrapTotes,
      },
      dirty: true,
      setPopup: true,
    };
    return newPayload;
  } else if (
    parentName === "/containerTypeMaintenance" &&
    selectedMenu === "Management"
  ) {
    const newPayload: IInitialStateDuType = {
      ...iInitialStateDuType,
      values: {
        legacyContainerHasValue: false,
        containerType: undefinedToStringConverter(value.ContainerType),
        containerName: undefinedToStringConverter(value.ContainerName),
        description: undefinedToStringConverter(value.Description),
        //customerType:value.CustomerType,
        // legacyContainerName:value.legacyContainerName,
        // legacyContainerType:value.legacyContainerType,
        // legacyDescription:value.legacyDescription,
        legacyContainerDetails: value?.LegacyContainerDetails?.map(
          (item: any) => {
            return {
              containerType: undefinedToStringConverter(item.ContainerType),
              containerName: undefinedToStringConverter(item.ContainerName),
              customerType: undefinedToStringConverter(item.CustomerType),
              description: undefinedToStringConverter(item.Description),
              isDefault: item?.IsDefault,
            };
          }
        ),
        linkedContainers: value.LinkedContainers?.map((item: any) => {
          return {
            linkedContainerType: item.LinkedContainerType,
            quantity: item.Quantity,
          };
        }),
        weight: value.Weight,
        volume: value.Volume,
        fullLength: value.FullLength,
        fullWidth: value.FullWidth,
        fullHeight: value.FullHeight,
        weightCap: value.WeightCap,
        minPickVolume: value.MinPickVolume,
        maxPickVolume: value.MaxPickVolume,
        lpIndicator: value.LpIndicator,
        mlpIndicator: value.MlpIndicator,
        muIndicator: value.MuIndicator,
        isLinkableContainer: value.IsLinkableContainer,
      },
      dirty: true,
      setPopup: true,
    };
    return newPayload;
  } else if ((parentName === "/product" &&
    (selectedMenu === "Query" ||
      selectedMenu === "Attributes" ||
      selectedMenu === "Measurements-Clothing" ||
      selectedMenu === "Measurements" ||
      selectedMenu === "Hierarchy")) ||
    (parentName === "/familyGroupAdmin" &&
      (selectedMenu === "Query" ||
        selectedMenu === "Attributes" ||
        selectedMenu === "Measurements-Clothing" ||
        selectedMenu === "Measurements" ||
        selectedMenu === "Hierarchy"))
  ) {
    const newPayload: IInitialStateProduct = {
      ...iInitialStateProduct,
      values: editPayload(value),
      dirty: true,
      setPopup: true,
    };
    return newPayload;
  }else if (
    (parentName === "/product" && selectedMenu === "Food Volumetrics")
  ) {
    const newPayload: IFoodVolumetricsReviewType = {
      ...initialStateFoodVolumetricsReviewType,
      values: {
        dcp: value.DCP,
        originalRowNumber: value.OriginalRowNumber,
        superCatDesc: value.SuperCatDesc,
        deptCode: value.DeptCode,
        commCode: value.CommCode,
        packSize: value.PackSize,
        skuNo: value.SkuNo,
        suppCode: value.SuppCode,
        suppName: value.SuppName,
        officeDesc: value.OfficeDesc,
        desc: value.Desc,
        breakPack: value.BreakPack,
        caseLengthMm: value.CaseLengthMm,
        caseWidthMm: value.CaseWidthMm,
        caseHeightMm: value.CaseHeightMm,
        caseWeightKg: value.CaseWeightKg,
        weightUom: value.WeightUom,
        casesPerLayer: value.CasesPerLayer,
        layersPerPallet: value.LayersPerPallet,
        casesPerPallet: value.CasesPerPallet,
        rejectionReason: value.RejectionReason,
        fileName: value.FileName,
        uploadDate: value.UploadDate,
        status: value.Status,
        overridenValidations: value.OverridenValidations ?? false
      },
      dirty: false,
      isFormValid: false,
      submitted: false,
      setPopup: true
    };

    return newPayload;
  } else {
    return iInitialStateDuType;
  }
};

export const editPayload = (value: any) => {
  const payload: IInitialStateProduct = {
    ...iInitialStateProduct,
    values: {
      id: value.Id,
      sainId: value.SainId,
      skuNumber: value.SkuNumber,
      catNumber: value.CatNumber,
      familyGroup: value.FamilyGroup,
      familyGroupDescription: value.FamilyGroupDescription,
      familyGroupNew: value.FamilyGroupNew,
      packSize: value.PackSize,
      productType: value.ProductType ? value.ProductType : "",
      newLine: setCheckBoxData(value.NewLine),
      createdDate: moment(value.CreatedDate).format("YYYY-MM-DD"),
      updatedDate: moment(value.UpdatedDate).format("YYYY-MM-DD"),
      updatedBy: value.UpdatedBy,
      description: value.Description,
      activeDate: value.ActiveDate,
      breakPack: value.DimensionData?.BreakPackIndicator,
      businessUnit: value.BusinessUnit,
      businessUnitDesc: value.BusinessUnitDesc,
      category: value.Category,
      categoryDesc: value.CategoryDesc,
      company: value.Company,
      conveyable: value.Conveyable,
      ean: value.EAN,
      error: value.Error,
      //FamilyGroupWithDescription: value.FamilyGroupWithDescription,
      grabInBox: value.GrabInBox,
      hasWarnings: value.HasWarnings,
      hazardous: setCheckBoxData(value.Hazardous),
      hazardousCode: value.HazardousCode
        ? value.HazardousCode?.toUpperCase()
        : null,
      hi: value.Hi,
      innerHeight: value.InnerHeight,
      innerLength: value.InnerLength,
      innerNetWeight: value.InnerNetWeight,
      innerWeight: value.InnerWeight,
      innerWidth: value.InnerWidth,
      //isActive: value.IsActive,
      lifecycle: value.Lifecycle,
      manual: value.DimensionData?.Manual,
      measurementRequired: value.MeasurementRequired,
      merchandisingUnit: value.MeasurementRequired,
      minimumLifeOnIssue: value.MinimumLifeOnIssue,
      minimumLifeOnReceipt: value.MinimumLifeOnReceipt,
      mloi: value.MLOI,
      mlor: value.MLOR,
      muType: value.MUType ? value.MUType?.toUpperCase() : null,
      multiPart: value.MultiPart,
      nestedItem: setCheckBoxData(value.NestedItem),
      nestIncrement: value.NestedIncrement,
      oldFamilyGroup: value.OldFamilyGroup,
      outerHeight: value.OuterHeight,
      outerLength: value.OuterLength,
      outerNetWeight: value.OuterNetWeight,
      outerWeight: value.OuterWeight,
      outerWidth: value.OuterWidth,
      segment: value.Segment,
      segmentDesc: value.SegmentDesc,
      skuCount: value.SkuCount,
      subCategory: value.SubCategory,
      subCategoryDesc: value.SubCategoryDesc,
      superCatDesc: value.SuperCatDesc,
      superCategory: value.SuperCategory,
      ti: value.Ti,
      tuc: value.TUC,
      twoPersonLift: setCheckBoxData(value.TwoPersonLift),
      uglies: setCheckBoxData(value.Uglies),
      unitOfMeasure: value.UnitOfMeasure,
      validation: value.Validation,
      warehouseId: value.WarehouseId,
      alias: value.Alias,
      merchandiseType: value.MerchandiseType,
      breakPackIndicator: value.DimensionData?.BreakPackIndicator,
      outerDimensions: {
        height: value.DimensionData?.OuterDimensions?.Height,
        heightUOM: value.DimensionData?.OuterDimensions?.HeightUOM
          ? value.DimensionData?.OuterDimensions?.HeightUOM
          : DimensionLengthUOMOptions[0].value,
        hi: value.DimensionData?.OuterDimensions?.Hi,
        length: value.DimensionData?.OuterDimensions?.Length,
        lengthUOM: value.DimensionData?.OuterDimensions?.LengthUOM
          ? value.DimensionData?.OuterDimensions?.LengthUOM
          : DimensionLengthUOMOptions[0].value,
        ti: value.DimensionData?.OuterDimensions?.Ti,
        weight: value.DimensionData?.OuterDimensions?.Weight,
        weightUOM: value.DimensionData?.OuterDimensions?.WeightUOM
          ? value.DimensionData?.OuterDimensions?.WeightUOM
          : DimensionWeightUOMOptions[0].value,
        volume: value.DimensionData?.OuterDimensions?.Volume,
        volumeUOM: value.DimensionData?.OuterDimensions?.VolumeUOM,
        width: value.DimensionData?.OuterDimensions?.Width,
        widthUOM: value.DimensionData?.OuterDimensions?.WidthUOM
          ? value.DimensionData?.OuterDimensions?.WidthUOM
          : DimensionLengthUOMOptions[0].value,
        breakPackQty: value.DimensionData?.OuterDimensions?.BreakPackQty,
      },
      innerDimensions: {
        height: value.DimensionData?.InnerDimensions?.Height,
        heightUOM: value.DimensionData?.InnerDimensions?.HeightUOM
          ? value.DimensionData?.InnerDimensions?.HeightUOM
          : DimensionLengthUOMOptions[0].value,
        hi: value.DimensionData?.InnerDimensions?.Hi,
        length: value.DimensionData?.InnerDimensions?.Length,
        lengthUOM: value.DimensionData?.InnerDimensions?.LengthUOM
          ? value.DimensionData?.InnerDimensions?.LengthUOM
          : DimensionLengthUOMOptions[0].value,
        ti: value.DimensionData?.InnerDimensions?.Ti,
        weight: value.DimensionData?.InnerDimensions?.Weight,
        weightUOM: value.DimensionData?.InnerDimensions?.WeightUOM
          ? value.DimensionData?.InnerDimensions?.WeightUOM
          : DimensionWeightUOMOptions[0].value,
        volume: value.DimensionData?.InnerDimensions?.Volume,
        volumeUOM: value.DimensionData?.InnerDimensions?.VolumeUOM,
        width: value.DimensionData?.InnerDimensions?.Width,
        widthUOM: value.DimensionData?.InnerDimensions?.WidthUOM
          ? value.DimensionData?.InnerDimensions?.WidthUOM
          : DimensionLengthUOMOptions[0].value,
      },
      automationAdaptoSystem: value.AutomationAdaptoSystem,
      automationMinTotes: value.AutomationMinTotes,
      automationToteFill: value.AutomationToteFill,
      highRisk: setCheckBoxData(value.HighRisk),
      strapTotes: setCheckBoxData(value.StrapTotes),
      expiryDateRequired: setCheckBoxData(value.ExpiryDateRequired),
      pickPack: setCheckBoxData(value.PickPack),
      overridenValidations: value.DimensionData?.OverridenValidations ?? false,
    },
  };
  return payload.values;
};
